export const ANALYTICS_BASE = "/analytics";
// W2-S3 (ANL-003): ML-домен (dashboards/widgets/ml-models/data-sources/reports/
// metrics/predictions/system) разведён с AnalyticsController на отдельный префикс.
export const ANALYTICS_ML_BASE = `${ANALYTICS_BASE}/ml`;
export const ANALYTICS_ANOMALIES = `${ANALYTICS_BASE}/anomalies`;
export const ANALYTICS_RECOMMENDATIONS = `${ANALYTICS_BASE}/recommendations`;
